/**
 * 人行过街实体
 * zxw
 * 2024-09-26
 */
import React, { Component } from 'react';
import { Modal, Input,Row,Col, 
    message, InputNumber, Button, } from 'antd';
import $ from 'jquery';
import { AddRequestHeaders } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const MODULENAME = '人行过街';
const YEAR = new Date().getFullYear();

const { TextArea } = Input;

class Entity extends Component{
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            ulid: '',
            number: '',
            name: '',
            fullName: '',
            createYear: YEAR,
            hostMachine: '',
            hostMachineModel: '',
            hostMachineProductNumber: '',
            detachment: '',
            region: '',
            road: '',
            longitude: '',
            latitude: '',
            description: '',
        }
    }

    changeNumber = (e) =>{this.setState({number: e.target.value.replace(' ','')});}
    changeName = (e) =>{this.setState({name: e.target.value});}
    changeFullName = (e) =>{this.setState({fullName: e.target.value});}
    changeCreateYear = (value) =>{this.setState({ createYear: value});}
    changeHostMachine = (e) =>{ this.setState({ hostMachine: e.target.value.replace(' ','')});}
    changeHostMachineModel = (e) =>{ this.setState({ hostMachineModel: e.target.value.replace(' ','')});}
    changeHostMachineProductNumber = (e) =>{ this.setState({ hostMachineProductNumber: e.target.value.replace(' ','')});}
    changeDetachment = (e) =>{ this.setState({ detachment: e.target.value.replace(' ','')});}
    changeRegion = (e) =>{ this.setState({ region: e.target.value.replace(' ','')});}
    changeRoad = (e) =>{ this.setState({ road: e.target.value.replace(' ','')});}
    changeLongitude = (e) =>{this.setState({longitude: e.target.value});}
    changeLatitude = (e) =>{this.setState({latitude: e.target.value});}
    changeDescription = (e) =>{this.setState({description: e.target.value});}

    create = () =>{
        const _this = this;

        //  执行创建
        $.ajax({
            url: `${CNF.api}walkways`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data:JSON.stringify({
                'number': this.state.number,
                'name': this.state.name,
                'full_name': this.state.fullName,
                'host_machine': this.state.hostMachine,
                'host_machine_model': this.state.hostMachineModel,
                'host_machine_product_number': this.state.hostMachineProductNumber,
                'detachment': this.state.detachment,
                'region': this.state.region,
                'road': this.state.road,
                'create_year': this.state.createYear,
                'longitude': this.state.longitude,
                'latitude': this.state.latitude,
                'description': this.state.description,
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        _this.handleCancel();
                        _this.props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1.5);
                    _this.setState({loading: false});
                }
            }
        });
    };

    update = () =>{
        const _this = this;

        //  执行更新
        $.ajax({
            url: `${CNF.api}walkways/${this.state.ulid}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data:JSON.stringify({
                'action': 'UPDATE',
                'number': this.state.number,
                'name': this.state.name,
                'full_name': this.state.fullName,
                'host_machine': this.state.hostMachine,
                'host_machine_model': this.state.hostMachineModel,
                'host_machine_product_number': this.state.hostMachineProductNumber,
                'detachment': this.state.detachment,
                'region': this.state.region,
                'road': this.state.road,
                'create_year': this.state.createYear,
                'longitude': this.state.longitude,
                'latitude': this.state.latitude,
                'description': this.state.description,
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        _this.handleCancel();
                        _this.props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1.5);
                    _this.setState({loading: false});
                }
            }
        });
    };

    handleOk = () =>{
        //  参数校验
        if(this.state.number === ''){
            message.error('编码不能为空！');
            return;
        }
        if(this.state.name === ''){
            message.error('简称不能为空！');
            return;
        }
        if(this.state.fullName === ''){
            message.error('全称不能为空！');
            return;
        }
        this.setState({loading: true});
        if (this.props.record){
            this.update();
        }else{
            this.create();
        }
    };
    
    handleCancel = () =>{
        this.props.setIsModalOpen(false);
        this.setState({
            loading: false,
            ulid: '',
            number: '',
            name: '',
            fullName: '',
            createYear: YEAR,
            hostMachine: '',
            hostMachineModel: '',
            hostMachineProductNumber: '',
            detachment: '',
            region: '',
            road: '',
            longitude: '',
            latitude: '',
            description: '',
        });
    };

    componentDidUpdate(){
        if (this.props.record && this.state.ulid !== this.props.record.key){
            this.setState({
                record: this.props.record,
                ulid: this.props.record.key,
                number: this.props.record.number,
                name: this.props.record.name,
                fullName: this.props.record.full_name,
                hostMachine: this.props.record.host_machine,
                hostMachineModel: this.props.record.host_machine_model,
                hostMachineProductNumber: this.props.record.host_machine_product_number,
                detachment: this.props.record.detachment,
                region: this.props.record.region,
                road: this.props.record.road,
                createYear: this.props.record.create_year?this.props.record.create_year:YEAR,
                longitude: this.props.record.longitude,
                latitude: this.props.record.latitude,
                description: this.props.record.description,
            });
        }
    }
  
    render() {
        return (
            <div>
                <Modal
                    width={800}
                    title={(this.props.record?'修改':'创建') + MODULENAME}
                    open={this.props.isModalOpen}
                    onCancel={this.handleCancel}
                    keyboard={true}
                    okText='确认'
                    cancelText='取消'
                    footer={[
                        <Button key="cancel" disabled={this.state.loading} onClick={this.handleCancel}>取消</Button>,
                        <Button key="ok" type="primary" disabled={this.state.loading} onClick={this.handleOk}>确定</Button>,
                      ]}
                    style={{ top: 0 }}
                    okButtonProps={{ disabled: this.state.loading }}
                >
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={3}>简称：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeName}
                                placeholder='必填字段'
                                value={this.state.name}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2}>编码：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeNumber}
                                placeholder='必填字段'
                                value={this.state.number}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={3}>全称：</Col>
                        <Col span={21}>
                            <Input
                                onChange={this.changeFullName}
                                placeholder='必填字段'
                                value={this.state.fullName}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>所属区域：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeRegion}
                                value={this.state.region}
                                placeholder='比如：鹤城区'
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2}>建设年份：</Col>
                        <Col span={8}>
                            <InputNumber
                                onChange={this.changeCreateYear}
                                value={this.state.createYear}
                                min={1949}
                                max={2049}
                                step='1'
                                style={{ width: '100%' }} 
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>主机：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeHostMachine}
                                value={this.state.hostMachine}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2} style={{ lineHeight: 2.2 }}>型号：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeHostMachineModel}
                                value={this.state.hostMachineModel}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>产品编码：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeHostMachineProductNumber}
                                value={this.state.hostMachineProductNumber}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>关联道路：</Col>
                        <Col span={21}>
                            <Input
                                onChange={this.changeRoad}
                                value={this.state.road}
                                placeholder='多条路用逗号（，）隔开'
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>经度：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeLongitude}
                                value={this.state.longitude}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2}>纬度：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeLatitude}
                                value={this.state.latitude}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>备注：</Col>
                        <Col span={21}>
                            <TextArea
                                placeholder='备注可写在这里...'
                                autoSize={{ minRows: 2, maxRows: 4 }}
                                onChange={this.changeDescription}
                                disabled={this.state.loading}
                                value={this.state.description}
                            />
                        </Col>
                    </Row>
                </Modal>
            </div>
        );
    }
}

export default Entity